import * as styles from '../styles/containers/Index.less';
import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { withTranslation, WithTranslation } from "react-i18next";
import Authenticated from './Authenticated';
import NotAuthenticated from './NotAuthenticated';
import UserTargets from '../components/main/UserTargets';
import UserCustomers from '../components/main/UserCustomers';
import Users from '../components/main/Users';
import UserDashboards from '../components/main/UserDashboards';
import SuperuserIsActive from './SuperuserIsActive';
import { useActions } from '../hooks/useActions';
import { useAppSelector } from '../store/hooks';
import { EntityId } from '../types/models';

const Main = (props: WithTranslation) => {
  const { t } = props; // [t, i18n]
  const actions = useActions();
  const navigate = useNavigate();
  const [filterCustomers, setFilterCustomers] = useState<EntityId[]>([]);

  const isAuthenticated = useAppSelector((store) => store.auth.isAuthenticated);
  const targets = useAppSelector((store) => store.customer.targets);
  const isTargetsLoading = useAppSelector((store) => store.customer.isTargetsLoading);
  const isDashboardsLoading = useAppSelector((store) => store.customer.isDashboardsLoading);
  const isUsersLoading = useAppSelector((store) => store.customer.isUsersLoading);

  // The only place main-page data loads. Mount-only is enough: login is a full
  // page load, so Main always mounts with auth already settled — there is no
  // in-page login transition to react to.
  useEffect(() => {
    if (isAuthenticated) {
      actions.fetchUsers('*');
      actions.fetchUserDashboards();
      actions.fetchUserCustomers(1);
      actions.fetchUserTargets();
    } else {
      console.info('Not authenticated.');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- mount-only by design

  const onLogin = () => actions.login();

  // Called from UserCustomers (child component).
  const handleCustomerFilter = (filterList: EntityId[]) => {
    setFilterCustomers(filterList);
    navigate('/');
  };

  return (
    <div className={styles.content}>
      <NotAuthenticated>
        {/* No onClick on the icon — it bubbles to the anchor; a second handler fired login twice. */}
        <a className={styles.login} onClick={onLogin}>
          {t('login.in')} <i className="fa fa-sign-in" aria-hidden="true"></i>
        </a>
      </NotAuthenticated>
      <Authenticated>
        <div className={styles.mainline}>
          <SuperuserIsActive>
            <div className={styles.mainlineleft}>
              <UserCustomers
                onSetFilter={handleCustomerFilter}
                isLoading={isDashboardsLoading}/>
            </div>
          </SuperuserIsActive>
          <SuperuserIsActive>
            <div className={styles.mainlineleft}>
              <Users
                filterCustomers={filterCustomers}
                isLoading={isUsersLoading}/>
            </div>
          </SuperuserIsActive>
          <div className={styles.mainlineleft}>
            <UserTargets
              targets={targets}
              isLoading={isTargetsLoading}/>
          </div>
          <div className={styles.mainlineright}>
            <h2 className={styles.title}>
              {t('main.dashboards')}
              <Link className="button success" to="/dashboard">
                <i className="fa fa-plus-square"></i>
              </Link>
            </h2>
            <UserDashboards
              filterCustomers={filterCustomers}
              isLoading={isDashboardsLoading}
            />
          </div>
        </div>
      </Authenticated>
    </div>
  );
};

export default withTranslation('common')(Main);
